import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GoogleMapsService } from '../../../services/google-maps/google.maps.service';

@Injectable({
  providedIn: 'root',
})
export class PostcodeSuggestionService {
  constructor(private googleMapsService: GoogleMapsService) {}

  /**
   * @description Retrieves an array from Google Places Autocomplete
   * library matching a postcodeTerm string
   */
  getSuggestions(postcodeTerm: string): Observable<string[]> {
    if (!postcodeTerm) {
      return of([]);
    }

    return new Observable(observer => {
      this.googleMapsService.loadGoogleMapsApi().then(() => {
        this.googleMapsService.getSuggestions(postcodeTerm)
          .then(results => {
            observer.next(results);
            observer.complete();
          })
          .catch(error => {
            console.error('Failed to get suggestions:', error);
            observer.error([]);
            observer.complete();
          });
      }).catch(error => {
        console.error('Failed to load Google Maps API:', error);
        observer.error([]);
        observer.complete();
      });
    });
  }
}
